export default {
  computed: {
    $typeAheadAboutsTimezone() {
      return [
        {
          value2: "Dateline Standard Time",
          value: "DST",
          offset: -12,
          isdst: false,
          text: "(UTC-12:00) International Date Line West",
          utc: ["Etc/GMT+12"]
        },
        {
          value2: "UTC-11",
          value: "U",
          offset: -11,
          isdst: false,
          text: "(UTC-11:00) Coordinated Universal Time-11",
          utc: [
            "Etc/GMT+11",
            "Pacific/Midway",
            "Pacific/Niue",
            "Pacific/Pago_Pago"
          ]
        },
        {
          value2: "Hawaiian Standard Time",
          value: "HST",
          offset: -10,
          isdst: false,
          text: "(UTC-10:00) Hawaii",
          utc: [
            "Etc/GMT+10",
            "Pacific/Honolulu",
            "Pacific/Johnston",
            "Pacific/Rarotonga",
            "Pacific/Tahiti"
          ]
        },
        {
          value2: "Alaskan Standard Time",
          value: "AKDT",
          offset: -8,
          isdst: true,
          text: "(UTC-09:00) Alaska",
          utc: [
            "America/Anchorage",
            "America/Juneau",
            "America/Nome",
            "America/Sitka",
            "America/Yakutat"
          ]
        },
        {
          value2: "Pacific Standard Time (Mexico)",
          value: "PDT",
          offset: -7,
          isdst: true,
          text: "(UTC-08:00) Baja California",
          utc: ["America/Santa_Isabel"]
        },
        {
          value2: "Pacific Daylight Time",
          value: "PDT",
          offset: -7,
          isdst: true,
          text: "(UTC-07:00) Pacific Time (US & Canada)",
          utc: [
            "America/Dawson",
            "America/Los_Angeles",
            "America/Tijuana",
            "America/Vancouver",
            "America/Whitehorse"
          ]
        },
        {
          value2: "Pacific Standard Time",
          value: "PST",
          offset: -8,
          isdst: false,
          text: "(UTC-08:00) Pacific Time (US & Canada)",
          utc: [
            "America/Dawson",
            "America/Los_Angeles",
            "America/Tijuana",
            "America/Vancouver",
            "America/Whitehorse",
            "PST8PDT"
          ]
        },
        {
          value2: "US Mountain Standard Time",
          value: "UMST",
          offset: -7,
          isdst: false,
          text: "(UTC-07:00) Arizona",
          utc: [
            "America/Creston",
            "America/Dawson_Creek",
            "America/Hermosillo",
            "America/Phoenix",
            "Etc/GMT+7"
          ]
        },
        {
          value2: "Mountain Standard Time (Mexico)",
          value: "MDT",
          offset: -6,
          isdst: true,
          text: "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
          utc: ["America/Chihuahua", "America/Mazatlan"]
        },
        {
          value2: "Mountain Standard Time",
          value: "MDT",
          offset: -6,
          isdst: true,
          text: "(UTC-07:00) Mountain Time (US & Canada)",
          utc: [
            "America/Boise",
            "America/Cambridge_Bay",
            "America/Denver",
            "America/Edmonton",
            "America/Inuvik",
            "America/Ojinaga",
            "America/Yellowknife",
            "MST7MDT"
          ]
        },
        {
          value2: "Central America Standard Time",
          value: "CAST",
          offset: -6,
          isdst: false,
          text: "(UTC-06:00) Central America",
          utc: [
            "America/Belize",
            "America/Costa_Rica",
            "America/El_Salvador",
            "America/Guatemala",
            "America/Managua",
            "America/Tegucigalpa",
            "Etc/GMT+6",
            "Pacific/Galapagos"
          ]
        },
        {
          value2: "Central Standard Time",
          value: "CDT",
          offset: -5,
          isdst: true,
          text: "(UTC-06:00) Central Time (US & Canada)",
          utc: [
            "America/Chicago",
            "America/Indiana/Knox",
            "America/Indiana/Tell_City",
            "America/Matamoros",
            "America/Menominee",
            "America/North_Dakota/Beulah",
            "America/North_Dakota/Center",
            "America/North_Dakota/New_Salem",
            "America/Rainy_River",
            "America/Rankin_Inlet",
            "America/Resolute",
            "America/Winnipeg",
            "CST6CDT"
          ]
        },
        {
          value2: "Central Standard Time (Mexico)",
          value: "CDT",
          offset: -5,
          isdst: true,
          text: "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
          utc: [
            "America/Bahia_Banderas",
            "America/Cancun",
            "America/Merida",
            "America/Mexico_City",
            "America/Monterrey"
          ]
        },
        {
          value2: "Canada Central Standard Time",
          value: "CCST",
          offset: -6,
          isdst: false,
          text: "(UTC-06:00) Saskatchewan",
          utc: ["America/Regina", "America/Swift_Current"]
        },
        {
          value2: "SA Pacific Standard Time",
          value: "SPST",
          offset: -5,
          isdst: false,
          text: "(UTC-05:00) Bogota, Lima, Quito",
          utc: [
            "America/Bogota",
            "America/Cayman",
            "America/Coral_Harbour",
            "America/Eirunepe",
            "America/Guayaquil",
            "America/Jamaica",
            "America/Lima",
            "America/Panama",
            "America/Rio_Branco",
            "Etc/GMT+5"
          ]
        },
        {
          value2: "Eastern Standard Time",
          value: "EDT",
          offset: -4,
          isdst: true,
          text: "(UTC-05:00) Eastern Time (US & Canada)",
          utc: [
            "America/Detroit",
            "America/Havana",
            "America/Indiana/Petersburg",
            "America/Indiana/Vincennes",
            "America/Indiana/Winamac",
            "America/Iqaluit",
            "America/Kentucky/Monticello",
            "America/Louisville",
            "America/Montreal",
            "America/Nassau",
            "America/New_York",
            "America/Nipigon",
            "America/Pangnirtung",
            "America/Port-au-Prince",
            "America/Thunder_Bay",
            "America/Toronto",
            "EST5EDT"
          ]
        },
        {
          value2: "US Eastern Standard Time",
          value: "UEDT",
          offset: -4,
          isdst: true,
          text: "(UTC-05:00) Indiana (East)",
          utc: [
            "America/Indiana/Marengo",
            "America/Indiana/Vevay",
            "America/Indianapolis"
          ]
        },
        {
          value2: "Venezuela Standard Time",
          value: "VST",
          offset: -4.5,
          isdst: false,
          text: "(UTC-04:30) Caracas",
          utc: ["America/Caracas"]
        },
        {
          value2: "Paraguay Standard Time",
          value: "PYT",
          offset: -4,
          isdst: false,
          text: "(UTC-04:00) Asuncion",
          utc: ["America/Asuncion"]
        },
        {
          value2: "Atlantic Standard Time",
          value: "ADT",
          offset: -3,
          isdst: true,
          text: "(UTC-04:00) Atlantic Time (Canada)",
          utc: [
            "America/Glace_Bay",
            "America/Goose_Bay",
            "America/Halifax",
            "America/Moncton",
            "America/Thule",
            "Atlantic/Bermuda"
          ]
        },
        {
          value2: "Central Brazilian Standard Time",
          value: "CBST",
          offset: -4,
          isdst: false,
          text: "(UTC-04:00) Cuiaba",
          utc: ["America/Campo_Grande", "America/Cuiaba"]
        },
        {
          value2: "SA Western Standard Time",
          value: "SWST",
          offset: -4,
          isdst: false,
          text: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
          utc: [
            "America/Anguilla",
            "America/Antigua",
            "America/Aruba",
            "America/Barbados",
            "America/Blanc-Sablon",
            "America/Boa_Vista",
            "America/Curacao",
            "America/Dominica",
            "America/Grand_Turk",
            "America/Grenada",
            "America/Guadeloupe",
            "America/Guyana",
            "America/Kralendijk",
            "America/La_Paz",
            "America/Lower_Princes",
            "America/Manaus",
            "America/Marigot",
            "America/Martinique",
            "America/Montserrat",
            "America/Port_of_Spain",
            "America/Porto_Velho",
            "America/Puerto_Rico",
            "America/Santo_Domingo",
            "America/St_Barthelemy",
            "America/St_Kitts",
            "America/St_Lucia",
            "America/St_Thomas",
            "America/St_Vincent",
            "America/Tortola",
            "Etc/GMT+4"
          ]
        },
        {
          value2: "Pacific SA Standard Time",
          value: "PSST",
          offset: -4,
          isdst: false,
          text: "(UTC-04:00) Santiago",
          utc: ["America/Santiago", "Antarctica/Palmer"]
        },
        {
          value2: "Newfoundland Standard Time",
          value: "NDT",
          offset: -2.5,
          isdst: true,
          text: "(UTC-03:30) Newfoundland",
          utc: ["America/St_Johns"]
        },
        {
          value2: "E. South America Standard Time",
          value: "ESAST",
          offset: -3,
          isdst: false,
          text: "(UTC-03:00) Brasilia",
          utc: ["America/Sao_Paulo"]
        },
        {
          value2: "Argentina Standard Time",
          value: "AST",
          offset: -3,
          isdst: false,
          text: "(UTC-03:00) Buenos Aires",
          utc: [
            "America/Argentina/La_Rioja",
            "America/Argentina/Rio_Gallegos",
            "America/Argentina/Salta",
            "America/Argentina/San_Juan",
            "America/Argentina/San_Luis",
            "America/Argentina/Tucuman",
            "America/Argentina/Ushuaia",
            "America/Buenos_Aires",
            "America/Catamarca",
            "America/Cordoba",
            "America/Jujuy",
            "America/Mendoza"
          ]
        },
        {
          value2: "SA Eastern Standard Time",
          value: "SEST",
          offset: -3,
          isdst: false,
          text: "(UTC-03:00) Cayenne, Fortaleza",
          utc: [
            "America/Araguaina",
            "America/Belem",
            "America/Cayenne",
            "America/Fortaleza",
            "America/Maceio",
            "America/Paramaribo",
            "America/Recife",
            "America/Santarem",
            "Antarctica/Rothera",
            "Atlantic/Stanley",
            "Etc/GMT+3"
          ]
        },
        {
          value2: "Greenland Standard Time",
          value: "GDT",
          offset: -3,
          isdst: true,
          text: "(UTC-03:00) Greenland",
          utc: ["America/Godthab"]
        },
        {
          value2: "Montevideo Standard Time",
          value: "MST",
          offset: -3,
          isdst: false,
          text: "(UTC-03:00) Montevideo",
          utc: ["America/Montevideo"]
        },
        {
          value2: "Bahia Standard Time",
          value: "BST",
          offset: -3,
          isdst: false,
          text: "(UTC-03:00) Salvador",
          utc: ["America/Bahia"]
        },
        {
          value2: "UTC-02",
          value: "U",
          offset: -2,
          isdst: false,
          text: "(UTC-02:00) Coordinated Universal Time-02",
          utc: ["America/Noronha", "Atlantic/South_Georgia", "Etc/GMT+2"]
        },
        {
          value2: "Mid-Atlantic Standard Time",
          value: "MDT",
          offset: -1,
          isdst: true,
          text: "(UTC-02:00) Mid-Atlantic - Old",
          utc: []
        },
        {
          value2: "Azores Standard Time",
          value: "ADT",
          offset: 0,
          isdst: true,
          text: "(UTC-01:00) Azores",
          utc: ["America/Scoresbysund", "Atlantic/Azores"]
        },
        {
          value2: "Cape Verde Standard Time",
          value: "CVST",
          offset: -1,
          isdst: false,
          text: "(UTC-01:00) Cape Verde Is.",
          utc: ["Atlantic/Cape_Verde", "Etc/GMT+1"]
        },
        {
          value2: "Morocco Standard Time",
          value: "MDT",
          offset: 1,
          isdst: true,
          text: "(UTC) Casablanca",
          utc: ["Africa/Casablanca", "Africa/El_Aaiun"]
        },
        {
          value2: "UTC",
          value: "UTC",
          offset: 0,
          isdst: false,
          text: "(UTC) Coordinated Universal Time",
          utc: ["America/Danmarkshavn", "Etc/GMT"]
        },
        {
          value2: "GMT Standard Time",
          value: "GMT",
          offset: 0,
          isdst: false,
          text: "(UTC) Edinburgh, London",
          utc: [
            "Europe/Isle_of_Man",
            "Europe/Guernsey",
            "Europe/Jersey",
            "Europe/London"
          ]
        },
        {
          value2: "British Summer Time",
          value: "BST",
          offset: 1,
          isdst: true,
          text: "(UTC+01:00) Edinburgh, London",
          utc: [
            "Europe/Isle_of_Man",
            "Europe/Guernsey",
            "Europe/Jersey",
            "Europe/London"
          ]
        },
        {
          value2: "GMT Standard Time",
          value: "GDT",
          offset: 1,
          isdst: true,
          text: "(UTC) Dublin, Lisbon",
          utc: [
            "Atlantic/Canary",
            "Atlantic/Faeroe",
            "Atlantic/Madeira",
            "Europe/Dublin",
            "Europe/Lisbon"
          ]
        },
        {
          value2: "Greenwich Standard Time",
          value: "GST",
          offset: 0,
          isdst: false,
          text: "(UTC) Monrovia, Reykjavik",
          utc: [
            "Africa/Abidjan",
            "Africa/Accra",
            "Africa/Bamako",
            "Africa/Banjul",
            "Africa/Bissau",
            "Africa/Conakry",
            "Africa/Dakar",
            "Africa/Freetown",
            "Africa/Lome",
            "Africa/Monrovia",
            "Africa/Nouakchott",
            "Africa/Ouagadougou",
            "Africa/Sao_Tome",
            "Atlantic/Reykjavik",
            "Atlantic/St_Helena"
          ]
        },
        {
          value2: "W. Europe Standard Time",
          value: "WEDT",
          offset: 2,
          isdst: true,
          text: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
          utc: [
            "Arctic/Longyearbyen",
            "Europe/Amsterdam",
            "Europe/Andorra",
            "Europe/Berlin",
            "Europe/Busingen",
            "Europe/Gibraltar",
            "Europe/Luxembourg",
            "Europe/Malta",
            "Europe/Monaco",
            "Europe/Oslo",
            "Europe/Rome",
            "Europe/San_Marino",
            "Europe/Stockholm",
            "Europe/Vaduz",
            "Europe/Vatican",
            "Europe/Vienna",
            "Europe/Zurich"
          ]
        },
        {
          value2: "Central Europe Standard Time",
          value: "CEDT",
          offset: 2,
          isdst: true,
          text: "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
          utc: [
            "Europe/Belgrade",
            "Europe/Bratislava",
            "Europe/Budapest",
            "Europe/Ljubljana",
            "Europe/Podgorica",
            "Europe/Prague",
            "Europe/Tirane"
          ]
        },
        {
          value2: "Romance Standard Time",
          value: "RDT",
          offset: 2,
          isdst: true,
          text: "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
          utc: [
            "Africa/Ceuta",
            "Europe/Brussels",
            "Europe/Copenhagen",
            "Europe/Madrid",
            "Europe/Paris"
          ]
        },
        {
          value2: "Central European Standard Time",
          value: "CEDT",
          offset: 2,
          isdst: true,
          text: "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
          utc: [
            "Europe/Sarajevo",
            "Europe/Skopje",
            "Europe/Warsaw",
            "Europe/Zagreb"
          ]
        },
        {
          value2: "W. Central Africa Standard Time",
          value: "WCAST",
          offset: 1,
          isdst: false,
          text: "(UTC+01:00) West Central Africa",
          utc: [
            "Africa/Algiers",
            "Africa/Bangui",
            "Africa/Brazzaville",
            "Africa/Douala",
            "Africa/Kinshasa",
            "Africa/Lagos",
            "Africa/Libreville",
            "Africa/Luanda",
            "Africa/Malabo",
            "Africa/Ndjamena",
            "Africa/Niamey",
            "Africa/Porto-Novo",
            "Africa/Tunis",
            "Etc/GMT-1"
          ]
        },
        {
          value2: "Namibia Standard Time",
          value: "NST",
          offset: 1,
          isdst: false,
          text: "(UTC+01:00) Windhoek",
          utc: ["Africa/Windhoek"]
        },
        {
          value2: "GTB Standard Time",
          value: "GDT",
          offset: 3,
          isdst: true,
          text: "(UTC+02:00) Athens, Bucharest",
          utc: [
            "Asia/Nicosia",
            "Europe/Athens",
            "Europe/Bucharest",
            "Europe/Chisinau"
          ]
        },
        {
          value2: "Middle East Standard Time",
          value: "MEDT",
          offset: 3,
          isdst: true,
          text: "(UTC+02:00) Beirut",
          utc: ["Asia/Beirut"]
        },
        {
          value2: "Egypt Standard Time",
          value: "EST",
          offset: 2,
          isdst: false,
          text: "(UTC+02:00) Cairo",
          utc: ["Africa/Cairo"]
        },
        {
          value2: "Syria Standard Time",
          value: "SDT",
          offset: 3,
          isdst: true,
          text: "(UTC+02:00) Damascus",
          utc: ["Asia/Damascus"]
        },
        {
          value2: "E. Europe Standard Time",
          value: "EEDT",
          offset: 3,
          isdst: true,
          text: "(UTC+02:00) E. Europe",
          utc: [
            "Asia/Nicosia",
            "Europe/Athens",
            "Europe/Bucharest",
            "Europe/Chisinau",
            "Europe/Helsinki",
            "Europe/Kiev",
            "Europe/Mariehamn",
            "Europe/Nicosia",
            "Europe/Riga",
            "Europe/Sofia",
            "Europe/Tallinn",
            "Europe/Uzhgorod",
            "Europe/Vilnius",
            "Europe/Zaporozhye"
          ]
        },
        {
          value2: "South Africa Standard Time",
          value: "SAST",
          offset: 2,
          isdst: false,
          text: "(UTC+02:00) Harare, Pretoria",
          utc: [
            "Africa/Blantyre",
            "Africa/Bujumbura",
            "Africa/Gaborone",
            "Africa/Harare",
            "Africa/Johannesburg",
            "Africa/Kigali",
            "Africa/Lubumbashi",
            "Africa/Lusaka",
            "Africa/Maputo",
            "Africa/Maseru",
            "Africa/Mbabane",
            "Etc/GMT-2"
          ]
        },
        {
          value2: "FLE Standard Time",
          value: "FDT",
          offset: 3,
          isdst: true,
          text: "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
          utc: [
            "Europe/Helsinki",
            "Europe/Kiev",
            "Europe/Mariehamn",
            "Europe/Riga",
            "Europe/Sofia",
            "Europe/Tallinn",
            "Europe/Uzhgorod",
            "Europe/Vilnius",
            "Europe/Zaporozhye"
          ]
        },
        {
          value2: "Turkey Standard Time",
          value: "TDT",
          offset: 3,
          isdst: false,
          text: "(UTC+03:00) Istanbul",
          utc: ["Europe/Istanbul"]
        },
        {
          value2: "Israel Standard Time",
          value: "JDT",
          offset: 3,
          isdst: true,
          text: "(UTC+02:00) Jerusalem",
          utc: ["Asia/Jerusalem"]
        },
        {
          value2: "Libya Standard Time",
          value: "LST",
          offset: 2,
          isdst: false,
          text: "(UTC+02:00) Tripoli",
          utc: ["Africa/Tripoli"]
        },
        {
          value2: "Jordan Standard Time",
          value: "JST",
          offset: 3,
          isdst: false,
          text: "(UTC+03:00) Amman",
          utc: ["Asia/Amman"]
        },
        {
          value2: "Arabic Standard Time",
          value: "AST",
          offset: 3,
          isdst: false,
          text: "(UTC+03:00) Baghdad",
          utc: ["Asia/Baghdad"]
        },
        {
          value2: "Kaliningrad Standard Time",
          value: "KST",
          offset: 3,
          isdst: false,
          text: "(UTC+02:00) Kaliningrad",
          utc: ["Europe/Kaliningrad"]
        },
        {
          value2: "Arab Standard Time",
          value: "AST",
          offset: 3,
          isdst: false,
          text: "(UTC+03:00) Kuwait, Riyadh",
          utc: [
            "Asia/Aden",
            "Asia/Bahrain",
            "Asia/Kuwait",
            "Asia/Qatar",
            "Asia/Riyadh"
          ]
        },
        {
          value2: "E. Africa Standard Time",
          value: "EAST",
          offset: 3,
          isdst: false,
          text: "(UTC+03:00) Nairobi",
          utc: [
            "Africa/Addis_Ababa",
            "Africa/Asmera",
            "Africa/Dar_es_Salaam",
            "Africa/Djibouti",
            "Africa/Juba",
            "Africa/Kampala",
            "Africa/Khartoum",
            "Africa/Mogadishu",
            "Africa/Nairobi",
            "Antarctica/Syowa",
            "Etc/GMT-3",
            "Indian/Antananarivo",
            "Indian/Comoro",
            "Indian/Mayotte"
          ]
        },
        {
          value2: "Moscow Standard Time",
          value: "MSK",
          offset: 3,
          isdst: false,
          text: "(UTC+03:00) Moscow, St. Petersburg, Volgograd, Minsk",
          utc: [
            "Europe/Kirov",
            "Europe/Moscow",
            "Europe/Simferopol",
            "Europe/Volgograd",
            "Europe/Minsk"
          ]
        },
        {
          value2: "Samara Time",
          value: "SAMT",
          offset: 4,
          isdst: false,
          text: "(UTC+04:00) Samara, Ulyanovsk, Saratov",
          utc: ["Europe/Astrakhan", "Europe/Samara", "Europe/Ulyanovsk"]
        },
        {
          value2: "Iran Standard Time",
          value: "IDT",
          offset: 4.5,
          isdst: true,
          text: "(UTC+03:30) Tehran",
          utc: ["Asia/Tehran"]
        },
        {
          value2: "Arabian Standard Time",
          value: "AST",
          offset: 4,
          isdst: false,
          text: "(UTC+04:00) Abu Dhabi, Muscat",
          utc: ["Asia/Dubai", "Asia/Muscat", "Etc/GMT-4"]
        },
        {
          value2: "Azerbaijan Standard Time",
          value: "ADT",
          offset: 5,
          isdst: true,
          text: "(UTC+04:00) Baku",
          utc: ["Asia/Baku"]
        },
        {
          value2: "Mauritius Standard Time",
          value: "MST",
          offset: 4,
          isdst: false,
          text: "(UTC+04:00) Port Louis",
          utc: ["Indian/Mahe", "Indian/Mauritius", "Indian/Reunion"]
        },
        {
          value2: "Georgian Standard Time",
          value: "GET",
          offset: 4,
          isdst: false,
          text: "(UTC+04:00) Tbilisi",
          utc: ["Asia/Tbilisi"]
        },
        {
          value2: "Caucasus Standard Time",
          value: "CST",
          offset: 4,
          isdst: false,
          text: "(UTC+04:00) Yerevan",
          utc: ["Asia/Yerevan"]
        },
        {
          value2: "Afghanistan Standard Time",
          value: "AST",
          offset: 4.5,
          isdst: false,
          text: "(UTC+04:30) Kabul",
          utc: ["Asia/Kabul"]
        },
        {
          value2: "West Asia Standard Time",
          value: "WAST",
          offset: 5,
          isdst: false,
          text: "(UTC+05:00) Ashgabat, Tashkent",
          utc: [
            "Antarctica/Mawson",
            "Asia/Aqtau",
            "Asia/Aqtobe",
            "Asia/Ashgabat",
            "Asia/Dushanbe",
            "Asia/Oral",
            "Asia/Samarkand",
            "Asia/Tashkent",
            "Etc/GMT-5",
            "Indian/Kerguelen",
            "Indian/Maldives"
          ]
        },
        {
          value2: "Yekaterinburg Time",
          value: "YEKT",
          offset: 5,
          isdst: false,
          text: "(UTC+05:00) Yekaterinburg",
          utc: ["Asia/Yekaterinburg"]
        },
        {
          value2: "Pakistan Standard Time",
          value: "PKT",
          offset: 5,
          isdst: false,
          text: "(UTC+05:00) Islamabad, Karachi",
          utc: ["Asia/Karachi"]
        },
        {
          value2: "India Standard Time",
          value: "IST",
          offset: 5.5,
          isdst: false,
          text: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
          utc: ["Asia/Kolkata"]
        },
        {
          value2: "Sri Lanka Standard Time",
          value: "SLST",
          offset: 5.5,
          isdst: false,
          text: "(UTC+05:30) Sri Jayawardenepura",
          utc: ["Asia/Colombo"]
        },
        {
          value2: "Nepal Standard Time",
          value: "NST",
          offset: 5.75,
          isdst: false,
          text: "(UTC+05:45) Kathmandu",
          utc: ["Asia/Kathmandu"]
        },
        {
          value2: "Central Asia Standard Time",
          value: "CAST",
          offset: 6,
          isdst: false,
          text: "(UTC+06:00) Nur-Sultan (Astana)",
          utc: [
            "Antarctica/Vostok",
            "Asia/Almaty",
            "Asia/Bishkek",
            "Asia/Qyzylorda",
            "Asia/Urumqi",
            "Etc/GMT-6",
            "Indian/Chagos"
          ]
        },
        {
          value2: "Bangladesh Standard Time",
          value: "BST",
          offset: 6,
          isdst: false,
          text: "(UTC+06:00) Dhaka",
          utc: ["Asia/Dhaka", "Asia/Thimphu"]
        },
        {
          value2: "Myanmar Standard Time",
          value: "MST",
          offset: 6.5,
          isdst: false,
          text: "(UTC+06:30) Yangon (Rangoon)",
          utc: ["Asia/Rangoon", "Indian/Cocos"]
        },
        {
          value2: "SE Asia Standard Time",
          value: "SAST",
          offset: 7,
          isdst: false,
          text: "(UTC+07:00) Bangkok, Hanoi, Jakarta",
          utc: [
            "Antarctica/Davis",
            "Asia/Bangkok",
            "Asia/Hovd",
            "Asia/Jakarta",
            "Asia/Phnom_Penh",
            "Asia/Pontianak",
            "Asia/Saigon",
            "Asia/Vientiane",
            "Etc/GMT-7",
            "Indian/Christmas"
          ]
        },
        {
          value2: "N. Central Asia Standard Time",
          value: "NCAST",
          offset: 7,
          isdst: false,
          text: "(UTC+07:00) Novosibirsk",
          utc: ["Asia/Novokuznetsk", "Asia/Novosibirsk", "Asia/Omsk"]
        },
        {
          value2: "China Standard Time",
          value: "CST",
          offset: 8,
          isdst: false,
          text: "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
          utc: ["Asia/Hong_Kong", "Asia/Macau", "Asia/Shanghai"]
        },
        {
          value2: "North Asia Standard Time",
          value: "NAST",
          offset: 8,
          isdst: false,
          text: "(UTC+08:00) Krasnoyarsk",
          utc: ["Asia/Krasnoyarsk"]
        },
        {
          value2: "Singapore Standard Time",
          value: "MPST",
          offset: 8,
          isdst: false,
          text: "(UTC+08:00) Kuala Lumpur, Singapore",
          utc: [
            "Asia/Brunei",
            "Asia/Kuala_Lumpur",
            "Asia/Kuching",
            "Asia/Makassar",
            "Asia/Manila",
            "Asia/Singapore",
            "Etc/GMT-8"
          ]
        },
        {
          value2: "W. Australia Standard Time",
          value: "WAST",
          offset: 8,
          isdst: false,
          text: "(UTC+08:00) Perth",
          utc: ["Antarctica/Casey", "Australia/Perth"]
        },
        {
          value2: "Taipei Standard Time",
          value: "TST",
          offset: 8,
          isdst: false,
          text: "(UTC+08:00) Taipei",
          utc: ["Asia/Taipei"]
        },
        {
          value2: "Ulaanbaatar Standard Time",
          value: "UST",
          offset: 8,
          isdst: false,
          text: "(UTC+08:00) Ulaanbaatar",
          utc: ["Asia/Choibalsan", "Asia/Ulaanbaatar"]
        },
        {
          value2: "North Asia East Standard Time",
          value: "NAEST",
          offset: 8,
          isdst: false,
          text: "(UTC+08:00) Irkutsk",
          utc: ["Asia/Irkutsk"]
        },
        {
          value2: "Japan Standard Time",
          value: "JST",
          offset: 9,
          isdst: false,
          text: "(UTC+09:00) Osaka, Sapporo, Tokyo",
          utc: [
            "Asia/Dili",
            "Asia/Jayapura",
            "Asia/Tokyo",
            "Etc/GMT-9",
            "Pacific/Palau"
          ]
        },
        {
          value2: "Korea Standard Time",
          value: "KST",
          offset: 9,
          isdst: false,
          text: "(UTC+09:00) Seoul",
          utc: ["Asia/Pyongyang", "Asia/Seoul"]
        },
        {
          value2: "Cen. Australia Standard Time",
          value: "CAST",
          offset: 9.5,
          isdst: false,
          text: "(UTC+09:30) Adelaide",
          utc: ["Australia/Adelaide", "Australia/Broken_Hill"]
        },
        {
          value2: "AUS Central Standard Time",
          value: "ACST",
          offset: 9.5,
          isdst: false,
          text: "(UTC+09:30) Darwin",
          utc: ["Australia/Darwin"]
        },
        {
          value2: "E. Australia Standard Time",
          value: "EAST",
          offset: 10,
          isdst: false,
          text: "(UTC+10:00) Brisbane",
          utc: ["Australia/Brisbane", "Australia/Lindeman"]
        },
        {
          value2: "AUS Eastern Standard Time",
          value: "AEST",
          offset: 10,
          isdst: false,
          text: "(UTC+10:00) Canberra, Melbourne, Sydney",
          utc: ["Australia/Melbourne", "Australia/Sydney"]
        },
        {
          value2: "West Pacific Standard Time",
          value: "WPST",
          offset: 10,
          isdst: false,
          text: "(UTC+10:00) Guam, Port Moresby",
          utc: [
            "Antarctica/DumontDUrville",
            "Etc/GMT-10",
            "Pacific/Guam",
            "Pacific/Port_Moresby",
            "Pacific/Saipan",
            "Pacific/Truk"
          ]
        },
        {
          value2: "Tasmania Standard Time",
          value: "TST",
          offset: 10,
          isdst: false,
          text: "(UTC+10:00) Hobart",
          utc: ["Australia/Currie", "Australia/Hobart"]
        },
        {
          value2: "Yakutsk Standard Time",
          value: "YST",
          offset: 9,
          isdst: false,
          text: "(UTC+09:00) Yakutsk",
          utc: ["Asia/Chita", "Asia/Khandyga", "Asia/Yakutsk"]
        },
        {
          value2: "Central Pacific Standard Time",
          value: "CPST",
          offset: 11,
          isdst: false,
          text: "(UTC+11:00) Solomon Is., New Caledonia",
          utc: [
            "Antarctica/Macquarie",
            "Etc/GMT-11",
            "Pacific/Efate",
            "Pacific/Guadalcanal",
            "Pacific/Kosrae",
            "Pacific/Noumea",
            "Pacific/Ponape"
          ]
        },
        {
          value2: "Vladivostok Standard Time",
          value: "VST",
          offset: 11,
          isdst: false,
          text: "(UTC+11:00) Vladivostok",
          utc: ["Asia/Sakhalin", "Asia/Ust-Nera", "Asia/Vladivostok"]
        },
        {
          value2: "New Zealand Standard Time",
          value: "NZST",
          offset: 12,
          isdst: false,
          text: "(UTC+12:00) Auckland, Wellington",
          utc: ["Antarctica/McMurdo", "Pacific/Auckland"]
        },
        {
          value2: "UTC+12",
          value: "U",
          offset: 12,
          isdst: false,
          text: "(UTC+12:00) Coordinated Universal Time+12",
          utc: [
            "Etc/GMT-12",
            "Pacific/Funafuti",
            "Pacific/Kwajalein",
            "Pacific/Majuro",
            "Pacific/Nauru",
            "Pacific/Tarawa",
            "Pacific/Wake",
            "Pacific/Wallis"
          ]
        },
        {
          value2: "Fiji Standard Time",
          value: "FST",
          offset: 12,
          isdst: false,
          text: "(UTC+12:00) Fiji",
          utc: ["Pacific/Fiji"]
        },
        {
          value2: "Magadan Standard Time",
          value: "MST",
          offset: 12,
          isdst: false,
          text: "(UTC+12:00) Magadan",
          utc: [
            "Asia/Anadyr",
            "Asia/Kamchatka",
            "Asia/Magadan",
            "Asia/Srednekolymsk"
          ]
        },
        {
          value2: "Kamchatka Standard Time",
          value: "KDT",
          offset: 13,
          isdst: true,
          text: "(UTC+12:00) Petropavlovsk-Kamchatsky - Old",
          utc: ["Asia/Kamchatka"]
        },
        {
          value2: "Tonga Standard Time",
          value: "TST",
          offset: 13,
          isdst: false,
          text: "(UTC+13:00) Nuku'alofa",
          utc: [
            "Etc/GMT-13",
            "Pacific/Enderbury",
            "Pacific/Fakaofo",
            "Pacific/Tongatapu"
          ]
        },
        {
          value2: "Samoa Standard Time",
          value: "SST",
          offset: 13,
          isdst: false,
          text: "(UTC+13:00) Samoa",
          utc: ["Pacific/Apia"]
        }
      ];
    }
  }
};
